/* Important Info component for the Crew Info info */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";

const CrewInfoManage = () => {

  return (
   <div>
    <Row className="my-3">
    <Col md={{span: 10, offset: 1}}>
    <div className={`px-3 py-2 ${styles.SubTitle6}`}>
    <h5 className={`text-center ${styles.Red }`} >MANAGE CREW</h5>  
    <hr className={`mt-2 mb-0`}/>
    <p className={`pt-2`}>
    Crew positions are divided into Callsheet Main Crew and Non-Callsheet Extra Crew.
    </p>
    <p className={`pt-3`}>
    <span className={`${styles.Red}`}>*</span> All Crew Members needed to access the app <span className={`${styles.Red}`}>MUST: <br/>
        -</span> Be <span className={`${styles.Red}`}>registered</span> here by clicking the Add User tab and given a <span className={`${styles.Red}`}>Permission</span>, see Permissions Info.<br/>
    <span className={`${styles.Red}`}>-</span> Be <span className={`${styles.Red}`}>added</span> to the Crew Info.
    </p>
    <h5 className={` mt-5`} >CALLSHEET MAIN CREW</h5>  
    <p className="pt-2" >
    <span className={`${styles.Red}`}>*</span> The Callsheet Main Crew will appear on the Callsheet and contains most primary Production Crew positions.
    </p> 
    <p className="pt-2" >
    <span className={`${styles.Red}`}>*</span> They are added on the Crew Info page by clicking the <span className={`${styles.Red}`}>Add Callsheet Main Crew</span> button
    and opening their department.
    </p> 
    <p className="pt-2" >
    <span className={`${styles.Red}`}>*</span> Their Name and Email <span className={`${styles.Red}`}>MUST</span> be inputted in their Department's Crew Position.
    </p>     
    <p className={`pt-2`}>
    <span className={`${styles.Red}`}>*</span> In turn the <span className={`${styles.Red}`}>Callname</span> which displays in their Position must be
    inputted here in the Add User form in their "Callname" field.
    </p>     
    <h5 className={`mt-5 `} >NON-CALLSHEET EXTRA CREW</h5>  
    <p className="pt-2" >
    <span className={`${styles.Red}`}>*</span> The Non-Callsheet Extra Crew will not appear on the Callsheet.
    </p>  
    <p className="pt-2" >
    <span className={`${styles.Red}`}>*</span> They are added to the Crew Info by clicking the <span className={`${styles.Red}`}>Non-Callsheet Extra Dept Positions</span> button 
    at the bottom of each Department page. 
    </p> 
    <p className={`${styles.Small} pt-3`} >
    Note: Please ensure the email entered in both places is correct.
    </p> 
    <p className={`${styles.Small} pt-2`} >
    Note: Some major Crew Positions in the Callsheet Main Crew section may 
    not be needed on the Callsheet. If so just leave that position blank and add them 
    to their Department's Extra Non-Callsheet section instead, e.g., Production Designer.
    </p> 
    <hr className={`mt-2 mb-0`}/>
    </div>
    </Col>
    </Row>
    </div>
)
}

export default CrewInfoManage 